import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import AppContext from '../../context/AppContext';
import { requestData } from '../../services/request';
import './ProductCard.css';

function ProductCard(props) {
  const { setIsLoading, setSelectedProduct } = useContext(AppContext);
  const {
    id,
    ref,
    cardPrice,
    cashPrice,
    name,
    description,
    size,
    manufacturer,
    thumbs,
    gender,
    tags,
    colors,
    material,
    status,
    cost,
    supplier,
    buyDate,
    promptDelivery,
  } = props.product

  const handleClick = async () => {
    setIsLoading(true);
    const selected = await requestData(`/clothes/${ref}`);
    setSelectedProduct(selected);
  };

  return (
    <div
      className="product-card"
      // id={`product-id`}
      onClick={handleClick}
    >
      <Link className="product-link" to={`/products/${ref}`}>
        <img
          src={thumbs[0]}
          alt={`product-id-${ref}`}
          className="product-card-image"
        />
        <div className="card-info">
          <p className="card-title">{name}</p>
          <p className="card-price">{`R$ ${cashPrice.toFixed(2)}`.replace('.', ',')}</p>
          <p className="card-reference">Em até 4x no cartão</p>
          <p className="card-reference">{`Ref.: ${ref}`}</p>
        </div>
        <button className="details-btn">Detalhes</button>
      </Link>
      <div className="card-tags">
        {
          status ? null : <div className="card-sold-blocked">Bloqueado</div>
        }
        {
          promptDelivery ? null : <div className="card-sold-out">Sob encomenda</div>
        }
      </div>
    </div>
  )
}

export default ProductCard